import React from 'react';
import { FeedbackModalType } from './types';
import CorrespondenceModalLoadable from './modals/CorrespondenceModal';
export const feedbackModalRenderer = (modalType, requestClose, params)=>{
    switch(modalType){
        case FeedbackModalType.CORRESPONDENCE:
            return /*#__PURE__*/ React.createElement(CorrespondenceModalLoadable, {
                requestClose: requestClose,
                messageId: params.messageId,
                streamId: params.streamId
            });
        default:
            return;
    }
};
export default feedbackModalRenderer;

//# sourceMappingURL=project-tools.js.map